.content {
  margin-left: 32px;
  margin-right: 32px;
  margin-top: 16px;
  margin-bottom: 16px;
  flex: 1;
  overflow: auto;
}
